/**
 * @generated SignedSource<<a2eb511fee9c945fa265897af1b7400a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MissionControlDeactivateSageIntacctInput = {
  companyId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type MissionControlDeactivateSageIntacctMutation$variables = {
  input: MissionControlDeactivateSageIntacctInput;
};
export type MissionControlDeactivateSageIntacctMutation$data = {
  readonly missionControlDeactivateSageIntacct: {
    readonly outcome: string | null;
    readonly errorMessage: string | null;
  } | null;
};
export type MissionControlDeactivateSageIntacctMutation = {
  variables: MissionControlDeactivateSageIntacctMutation$variables;
  response: MissionControlDeactivateSageIntacctMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MissionControlDeactivateSageIntacctPayload",
    "kind": "LinkedField",
    "name": "missionControlDeactivateSageIntacct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MissionControlDeactivateSageIntacctMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MissionControlDeactivateSageIntacctMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9e7f43b2585ba89718fe77e1023ac882",
    "id": null,
    "metadata": {},
    "name": "MissionControlDeactivateSageIntacctMutation",
    "operationKind": "mutation",
    "text": "mutation MissionControlDeactivateSageIntacctMutation(\n  $input: MissionControlDeactivateSageIntacctInput!\n) {\n  missionControlDeactivateSageIntacct(input: $input) {\n    outcome\n    errorMessage\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e822f76af3be76bfbd33941e7cc0e95";

export default node;
